define('lq/events/actions/mail',[
    'lq',
    'lq/events/actions/eventAction'
], function(lq, EventAction) {
    'use strict';
        
    function Mail(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(Mail, EventAction);

    Mail.typeName = 'Mail';

    Mail.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };
        
    Mail.prototype.createEventActionRequest = function () {
        return {
            eventActionType: 'SendMail',
            morphId: this.eventData.command
        };
    };

    Mail.prototype.execute = function (continuation) {
        if (this.eventIsEnabled('sent'))
            this.triggerEvent('sent', continuation);
        else
            continuation();
    };

    return Mail;
});
